module.exports = __webpack_public_path__ + "static/media/turks-and-caicos.34770cb3.svg";